import type { LedgerEntry, Member } from '@/types/member';

export const memberPlatforms = [
  'All platforms',
  'BloomCommerce',
  'NovaMarket',
  'Kartel',
  'Loop',
  'Vantage',
  'Cedar',
];

export const members: Member[] = [
  {
    id: 'mb-1001',
    name: 'Ava Thompson',
    email: 'ava.thompson@bloomcommerce.io',
    platform: 'BloomCommerce',
    tier: 'Elite',
    balance: 12480,
    lifetime: 48200,
    status: 'active',
    joined: '2024-02-11',
  },
  {
    id: 'mb-1002',
    name: 'Liam Chen',
    email: 'liam.chen@novamarket.com',
    platform: 'NovaMarket',
    tier: 'Pro',
    balance: 6240,
    lifetime: 22860,
    status: 'active',
    joined: '2024-03-02',
  },
  {
    id: 'mb-1003',
    name: 'Sofia Rossi',
    email: 'sofia.rossi@kartel.io',
    platform: 'Kartel',
    tier: 'Elite',
    balance: 9860,
    lifetime: 41300,
    status: 'active',
    joined: '2024-01-19',
  },
  {
    id: 'mb-1004',
    name: 'Noah Patel',
    email: 'noah.patel@bloomcommerce.io',
    platform: 'BloomCommerce',
    tier: 'Pro',
    balance: 3420,
    lifetime: 15120,
    status: 'active',
    joined: '2024-04-08',
  },
  {
    id: 'mb-1005',
    name: 'Maya Fischer',
    email: 'maya.fischer@loop.co',
    platform: 'Loop',
    tier: 'Starter',
    balance: 820,
    lifetime: 2140,
    status: 'active',
    joined: '2024-05-21',
  },
  {
    id: 'mb-1006',
    name: 'Daniel Okafor',
    email: 'daniel.okafor@novamarket.com',
    platform: 'NovaMarket',
    tier: 'Pro',
    balance: 5180,
    lifetime: 19640,
    status: 'active',
    joined: '2024-02-27',
  },
  {
    id: 'mb-1007',
    name: 'Emma Larsen',
    email: 'emma.larsen@vantage.app',
    platform: 'Vantage',
    tier: 'Elite',
    balance: 15920,
    lifetime: 52700,
    status: 'active',
    joined: '2023-12-04',
  },
  {
    id: 'mb-1008',
    name: 'Kai Nakamura',
    email: 'kai.nakamura@kartel.io',
    platform: 'Kartel',
    tier: 'Starter',
    balance: 460,
    lifetime: 1780,
    status: 'idle',
    joined: '2024-06-15',
  },
  {
    id: 'mb-1009',
    name: 'Isabella Moreau',
    email: 'isabella.moreau@cedar.com',
    platform: 'Cedar',
    tier: 'Pro',
    balance: 7310,
    lifetime: 26450,
    status: 'active',
    joined: '2024-03-30',
  },
  {
    id: 'mb-1010',
    name: 'Ethan Brooks',
    email: 'ethan.brooks@loop.co',
    platform: 'Loop',
    tier: 'Starter',
    balance: 1240,
    lifetime: 3960,
    status: 'active',
    joined: '2024-06-02',
  },
  {
    id: 'mb-1011',
    name: 'Priya Sharma',
    email: 'priya.sharma@bloomcommerce.io',
    platform: 'BloomCommerce',
    tier: 'Elite',
    balance: 11050,
    lifetime: 38900,
    status: 'active',
    joined: '2024-01-08',
  },
  {
    id: 'mb-1012',
    name: 'Marco Bianchi',
    email: 'marco.bianchi@vantage.app',
    platform: 'Vantage',
    tier: 'Pro',
    balance: 4870,
    lifetime: 17230,
    status: 'idle',
    joined: '2024-04-25',
  },
];

export const ledgerSources = [
  'All sources',
  'BloomCommerce',
  'NovaMarket',
  'Kartel',
  'Loop',
  'Vantage',
  'Cedar',
  'Dashboard',
  'API',
];

export const ledgerEntries: LedgerEntry[] = [
  {
    id: 'TXN-10241',
    member: 'Ava Thompson',
    memberId: 'mb-1001',
    type: 'redeem',
    points: -1200,
    balanceAfter: 12480,
    source: 'Dashboard',
    description: 'Specialty Coffee Voucher',
    time: '2 min ago',
  },
  {
    id: 'TXN-10240',
    member: 'Liam Chen',
    memberId: 'mb-1002',
    type: 'earn',
    points: 340,
    balanceAfter: 6240,
    source: 'BloomCommerce',
    description: 'Purchase #48213',
    time: '14 min ago',
  },
  {
    id: 'TXN-10239',
    member: 'Sofia Rossi',
    memberId: 'mb-1003',
    type: 'earn',
    points: 500,
    balanceAfter: 9860,
    source: 'NovaMarket',
    description: 'Referral bonus',
    time: '38 min ago',
  },
  {
    id: 'TXN-10238',
    member: 'Noah Patel',
    memberId: 'mb-1004',
    type: 'redeem',
    points: -800,
    balanceAfter: 3420,
    source: 'API',
    description: '10% Discount Voucher',
    time: '1 hr ago',
  },
  {
    id: 'TXN-10237',
    member: 'Maya Fischer',
    memberId: 'mb-1005',
    type: 'earn',
    points: 200,
    balanceAfter: 820,
    source: 'BloomCommerce',
    description: 'Signup bonus',
    time: '2 hr ago',
  },
  {
    id: 'TXN-10236',
    member: 'Daniel Okafor',
    memberId: 'mb-1006',
    type: 'adjust',
    points: 150,
    balanceAfter: 5180,
    source: 'Dashboard',
    description: 'Manual credit by admin',
    time: '3 hr ago',
  },
  {
    id: 'TXN-10235',
    member: 'Emma Larsen',
    memberId: 'mb-1007',
    type: 'earn',
    points: 1250,
    balanceAfter: 15920,
    source: 'Cedar',
    description: 'Order #1902 · $125 spend',
    time: '5 hr ago',
  },
  {
    id: 'TXN-10234',
    member: 'Kai Nakamura',
    memberId: 'mb-1008',
    type: 'earn',
    points: 120,
    balanceAfter: 460,
    source: 'Kartel',
    description: 'First purchase',
    time: '7 hr ago',
  },
  {
    id: 'TXN-10233',
    member: 'Isabella Moreau',
    memberId: 'mb-1009',
    type: 'redeem',
    points: -2500,
    balanceAfter: 7310,
    source: 'Dashboard',
    description: 'Branded Merch Bundle',
    time: '9 hr ago',
  },
  {
    id: 'TXN-10232',
    member: 'Ethan Brooks',
    memberId: 'mb-1010',
    type: 'earn',
    points: 260,
    balanceAfter: 1240,
    source: 'Loop',
    description: 'Order #7731',
    time: '11 hr ago',
  },
  {
    id: 'TXN-10231',
    member: 'Priya Sharma',
    memberId: 'mb-1011',
    type: 'redeem',
    points: -5000,
    balanceAfter: 11050,
    source: 'API',
    description: 'VIP Experience',
    time: '1 day ago',
  },
  {
    id: 'TXN-10230',
    member: 'Marco Bianchi',
    memberId: 'mb-1012',
    type: 'earn',
    points: 430,
    balanceAfter: 4870,
    source: 'Vantage',
    description: 'Milestone: 5 orders',
    time: '1 day ago',
  },
  {
    id: 'TXN-10229',
    member: 'Ava Thompson',
    memberId: 'mb-1001',
    type: 'earn',
    points: 680,
    balanceAfter: 15680,
    source: 'BloomCommerce',
    description: 'Order #48201 · $68 spend',
    time: '1 day ago',
  },
  {
    id: 'TXN-10228',
    member: 'Sofia Rossi',
    memberId: 'mb-1003',
    type: 'adjust',
    points: -300,
    balanceAfter: 9360,
    source: 'Dashboard',
    description: 'Correction: duplicate award',
    time: '2 days ago',
  },
];
